import { graphql } from '../../generated';

export const SEND_INVITE = graphql(`
  mutation SendInvite($companyId: ID!, $email: String!, $role: MembershipRole!, $comment: String) {
    invite(input: { companyId: $companyId, email: $email, role: $role, comment: $comment }) {
      membership {
        id
      }
    }
  }
`);

export const GET_INVITE = graphql(`
  query GetInvite($token: String!) {
    invite(token: $token) {
      company {
        name
      }
      createdAt
      expiresAt
      invitedBy {
        email
        name
      }
      invitedEmail
      role
    }
  }
`);

export const INVITE_VIEWER_EMAIL = graphql(`
  query InviteViewerEmail {
    viewer {
      email
    }
  }
`);

export const ACCEPT_SIGNUP_INVITE = graphql(`
  mutation AcceptSignupInvite(
    $inviteToken: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $password: String!
  ) {
    acceptSignupInvite(
      input: {
        inviteToken: $inviteToken
        email: $email
        firstName: $firstName
        lastName: $lastName
        password: $password
      }
    ) {
      membership {
        id
        companyId
      }
    }
  }
`);

export const ACCEPT_INVITE = graphql(`
  mutation AcceptInvite($inviteToken: String!) {
    acceptInvite(input: { inviteToken: $inviteToken }) {
      membership {
        id
        companyId
      }
    }
  }
`);
